/*!
 * stack-admin-theme (https://pixinvent.com/bootstrap-admin-template/stack)
 * Copyright 2017 PIXINVENT
 * Licensed under the Themeforest Standard Licenses
 */
!function(window,document,$){"use strict";var heightLeft=$(".nav-left + .tab-content").height();$("ul.nav-left").height(heightLeft);var heightRight=$(".nav-right + .tab-content").height();$("ul.nav-right").height(heightRight)}(window,document,jQuery);